import React, {
  useState,
  useRef,
  useContext,
  useLayoutEffect,
  useEffect,
} from 'react';
import BlueBookButton from 'chameleon/packages/blue-book-player/library/bluebook-button/BlueBookButton';
import useCurrentQuestionLoad from 'chameleon/packages/blue-book-player/hooks/useCurrentQuestionLoad';
import SubmitConfirmDialog from 'chameleon/packages/blue-book-player/InnerContainer/SubmitConfirmDialog';
import { BluebookContext } from 'chameleon/packages/blue-book-player/state/BluebookContext';
import { SET_IS_REVIEW_PAGE } from 'chameleon/packages/blue-book-player/state/reducer';
import CheckAnswerButton from '../../CheckAnswerButton';

const NavigationContainer = (props) => {
  const itemsApiRef = useRef();
  const [showSubmitConfirmDialog, setShowSubmitConfirmDialog] = useState(false);
  const [itemsArray, setItemsArray] = useState([]);
  const [currentItemIndex, setCurrentItemIndex] = useState(0);
  const [showNav, setShowNav] = useState(false);
  const [disabledNav, setDisabledNav] = useState(true);
  const [showBackButton, setShowBackButton] = useState(false);
  const { state: playerState, dispatch } = useContext(BluebookContext);
  const {
    isReviewPage,
    assignment,
    isLearnosityApiReady,
    isSubmitModalVisble,
  } = playerState;
  useEffect(() => {
    if (isSubmitModalVisble) {
      setShowSubmitConfirmDialog(true);
    }
  }, [isSubmitModalVisble]);

  const navigateToReviewPage = () => {
    dispatch({ type: SET_IS_REVIEW_PAGE, payload: true });
  };

  const navigateAwayFromReviewPage = () => {
    dispatch({ type: SET_IS_REVIEW_PAGE, payload: false });
  };

  const buttonsClassNames = 'h-[40px] w-[78px] !font-bold text-[14px]';
  const {
    learnosityApp,
    isImpersonating,
    isPreviewPlayer,
    immediateFeedbackFF,
    isDigitalExam,
  } = props;

  useCurrentQuestionLoad(learnosityApp, (itemIndex) => {
    itemsApiRef.current = learnosityApp.items();
    const learnosityItemsArray = Object.keys(learnosityApp?.getItems() || {});
    setItemsArray(learnosityItemsArray);

    setCurrentItemIndex(itemIndex);
    setShowNav(true);
    setDisabledNav(false);
    learnosityApp.on('item:changed', setCurrentItemIndex);
    return () => {
      learnosityApp.off('item:changed', setCurrentItemIndex);
    };
  });

  const navigateToItem = (itemReference, callback) => {
    setDisabledNav(true);
    itemsApiRef.current
      .goto(itemReference)
      .then(() => {
        setDisabledNav(false);
        callback?.();
      })
      .catch(() => {
        setDisabledNav(true);
      });
  };

  const onClickBack = () => {
    if (currentItemIndex === 0 && !isReviewPage) return;
    const previousItemReference = isReviewPage
      ? itemsArray[itemsArray.length - 1]
      : itemsArray[currentItemIndex - 1];
    navigateToItem(previousItemReference, () => {
      if (isReviewPage) navigateAwayFromReviewPage();
    });
  };

  const onClickNext = () => {
    if (currentItemIndex === itemsArray.length - 1) {
      navigateToReviewPage();
    } else {
      const nextItemReference = itemsArray[currentItemIndex + 1];
      navigateToItem(nextItemReference);
    }
  };
  const onClickSubmit = () => {
    setShowSubmitConfirmDialog(true);
  };

  const submitConfirmDialogProps = {
    learnosityApp,
    isImpersonating,
    setShowSubmitConfirmDialog,
    setCurrentItemIndex,
    isDigitalExam,
  };

  useLayoutEffect(() => {
    setShowBackButton(currentItemIndex > 0 || isReviewPage);
  }, [currentItemIndex, isReviewPage]);

  const renderNavButton = (condition, onClick, text, testId) => {
    return condition ? (
      <BlueBookButton
        isPrimary
        className={`${buttonsClassNames} ml-[12px]`}
        onClick={onClick}
        disabled={disabledNav}
        data-test-id={testId}
        data-cy={testId}
      >
        {text}
      </BlueBookButton>
    ) : null;
  };

  return (
    <div
      className="flex justify-end grow basis-0 flex-row"
      data-test-id="navigation-container"
    >
      {assignment?.hasImmediateFeedback &&
        immediateFeedbackFF &&
        isLearnosityApiReady && (
          <div className="bb-mobile:hidden">
            <CheckAnswerButton
              app={learnosityApp}
              isImpersonating={isImpersonating}
              immediateFeedbackAttempts={assignment?.immediateFeedbackAttempts}
            />
          </div>
        )}
      {showNav ? (
        <>
          {renderNavButton(showBackButton, onClickBack, 'Back', 'back-button')}
          {renderNavButton(
            isReviewPage && !isPreviewPlayer,
            onClickSubmit,
            'Submit',
            'submit-button',
          )}
          {renderNavButton(!isReviewPage, onClickNext, 'Next', 'next-button')}
        </>
      ) : null}
      {showSubmitConfirmDialog && (
        <SubmitConfirmDialog {...submitConfirmDialogProps} />
      )}
    </div>
  );
};

export default NavigationContainer;
